// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead___xvBB","bigColWidth":"Table_bigColWidth__1W5x1","biggerColWidth":"Table_biggerColWidth__2CBfx","row":"Table_row__1GMQZ","col":"Table_col__3aaEc"};